<div class="pv-input">
	@if (label) {
		<ic-label [help]="help" [missing]="missing" [missingText]="missingText" [required]="required">
			{{ label }}
		</ic-label>
	}
	<div class="border" [class.disabled]="disabled">
		<i aria-hidden="true" [class]="icon"> </i>
		<input
			data-test="date-input"
			type="text"
			[attr.disabled]="disabled || null"
			[class]="inputClass"
			[ngModel]="value()"
			[ngModelOptions]="{ standalone: true }"
			[placeholder]="placeholder"
			(blur)="onValueChange($any($event).target.value)"
		/>
		<i
			class="fa fa-caret-down select"
			data-test="open-date-picker-button"
			(focusClick)="toggleDatePicker()"
			(keydown.space)="toggleDatePicker()"
		>
		</i>
	</div>
	@if (showDatePicker) {
		<div class="dropdown-panel" [class.dropdown-panel--top]="top">
			<ic-date-picker
				class="day-picker"
				data-test="date-picker"
				[locale]="locale"
				[options]="datePickerOptions"
				[selDate]="selectedDate"
				(dateChanged)="selectDate($event)"
			/>
		</div>
	}
	<div class="error-content"><ng-content select=".errors" /></div>
</div>
